import _ from 'lodash';

export function displayPriceIncludeGst(value) {
  let price = value * 1.1;
  let priceToFormat = price;
  let prepend = '';
  if (price < 0) {
    priceToFormat = (price * -1);
    prepend = '- ';
  }
  return prepend + priceToFormat.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2
  });
}

export function firstNamePossessive(firstName) {
  if (!_.isNull(firstName) && firstName.length) {
    return firstName + "'s";
  }
  return 'My';
}

export function shortRef(ref) {
  if (!_.isNull(ref) && ref.length) {
    const parts = ref.split('-');
    parts.splice(1, 1);
    return parts.join('-');
  }
  return '';
}
